import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import PluInVue from './util/plugIn'
import '@vant/touch-emulator';
import './assets/scss/base.scss';

import Vant ,{Lazyload}from 'vant';
import Navigation from 'vue-navigation'
import 'vant/lib/index.css';

import './util/importJs';
import  './util/importXtloginScriptJs' 
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Print from 'vue-print-nb'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
var _ = require('lodash');
Vue.prototype.$_ = _;

const bus = new Vue()
Vue.prototype.bus = bus


Vue.use(Navigation, {router})
Vue.config.productionTip = false
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(Lazyload, {
preLoad: 1,
attempt: 1,
autoHeight: true,
observer: true,
observeParents: true
})
Vue.use(Vant);
Vue.use(PluInVue);
Vue.use(LoadingPlugin);
Vue.use(Antd);
Vue.use(Print)



import 'amfe-flexible'

new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js